/* Ondudes: Black Friday na stronie produktu. Tylko wyświetlanie: nie zmienia cen, wariantów ani koszyka.
   Pokazuje się sam między datą startu i końca (czas polski). Podgląd wcześniej: dodaj ?bf=1 do adresu. */
(function () {
  if (window.__onduBf) return;
  window.__onduBf = true;

  var cfgEl = document.querySelector('[data-ondu-bf]');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!cfg.enabled) return;

  function parseDate(s) {
    var m = String(s || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2}):(\d{2}))?$/);
    if (!m) return null;
    var hh = m[4] ? ('0' + m[4]).slice(-2) : '00';
    var iso = m[1] + '-' + m[2] + '-' + m[3] + 'T' + hh + ':' + (m[5] || '00') + ':00' + (cfg.tz || '+01:00');
    var d = new Date(iso);
    return isNaN(d) ? null : d;
  }
  var start = parseDate(cfg.start), end = parseDate(cfg.end);

  var preview = false;
  try {
    var q = new URLSearchParams(location.search).get('bf');
    if (q === '1') sessionStorage.setItem('onduBfPreview', '1');
    if (q === '0') sessionStorage.removeItem('onduBfPreview');
    preview = sessionStorage.getItem('onduBfPreview') === '1';
  } catch (e) {
    preview = /[?&]bf=1/.test(location.search);
  }
  if (window.Shopify && window.Shopify.designMode) preview = true;
  /* Podgląd innej wersji oferty: &bfmode=gifts (pary gratis), &bfmode=code (kod) albo &bfmode=sale (obniżka automatyczna) */
  try {
    var qm = new URLSearchParams(location.search).get('bfmode');
    if (qm === 'code' || qm === 'gifts' || qm === 'sale') sessionStorage.setItem('onduBfMode', qm);
    if (new URLSearchParams(location.search).get('bf') === '0') sessionStorage.removeItem('onduBfMode');
    var sm = sessionStorage.getItem('onduBfMode');
    if (preview && sm) cfg.mode = sm;
  } catch (e) {}

  function isLive(now) {
    if (cfg.force || preview) return true;
    if (!start || !end) return false;
    return now >= start && now <= end;
  }
  if (!isLive(new Date())) return;

  var variants = cfg.variants || [];
  var byId = {};
  variants.forEach(function (v) { byId[String(v.id)] = v; });
  var gifts = cfg.mode !== 'code' && cfg.mode !== 'sale';
  var sale = cfg.mode === 'sale';
  var offers = (cfg.packs || []).filter(function (p) { return p && String(p.value || '').trim(); });

  function norm(s) { return String(s || '').trim().toLowerCase(); }
  function leadingNumber(str) { var m = String(str).match(/\d+/); return m ? parseInt(m[0], 10) : NaN; }
  function zl(cents) { return (Math.round(cents) / 100).toFixed(2).replace('.', ',') + ' zł'; }
  function pary(n) { var a = n % 10, b = n % 100; return n === 1 ? 'parę' : (a >= 2 && a <= 4 && (b < 12 || b > 14)) ? 'pary' : 'par'; }
  function root() { return document.querySelector('.product-information') || document; }
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function offerFor(val) {
    for (var i = 0; i < offers.length; i++) if (norm(offers[i].value) === norm(val)) return offers[i];
    return null;
  }
  function active(o) { return o && (gifts ? o.gift > 0 : o.off > 0); }

  function packIndex() {
    var sets = root().querySelectorAll('variant-picker fieldset');
    for (var i = 0; i < sets.length; i++) {
      var lg = sets[i].querySelector('legend');
      if (lg && norm(lg.textContent).indexOf(norm(cfg.packOption)) === 0) return i;
    }
    return -1;
  }
  function packFieldset() {
    var i = packIndex();
    return i < 0 ? null : root().querySelectorAll('variant-picker fieldset')[i];
  }
  function currentVariant() {
    var input = root().querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
    return input ? byId[String(input.value)] : null;
  }

  /* Cena pojedynczej pary: najniższa cena wariantu z 1 parą (punkt odniesienia dla oszczędności) */
  var idx = -1, singlePair = null, minByValue = {};
  function prepPrices() {
    idx = packIndex();
    if (idx < 0) return;
    minByValue = {};
    variants.forEach(function (v) {
      var val = v.options[idx];
      if (minByValue[val] === undefined || v.price < minByValue[val]) minByValue[val] = v.price;
    });
    singlePair = null;
    Object.keys(minByValue).forEach(function (val) {
      if (leadingNumber(val) === 1) singlePair = minByValue[val];
    });
  }

  function svgGift() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="3" y="9" width="18" height="12" rx="1.5"/><path d="M3 13h18M12 9v12"/><path d="M12 9c-1.5-3.5-6-4-6-1.5S9 9 12 9Zm0 0c1.5-3.5 6-4 6-1.5S15 9 12 9Z"/></svg>';
  }
  function svgTag() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M3 12V4h8l10 10-8 8L3 12Z"/><circle cx="7.5" cy="8.5" r="1.5"/></svg>';
  }

  /* 1. Pasek Black Friday nad nazwą produktu */
  var banner = null, countdownEl = null;
  function placeBanner() {
    if (banner && document.body.contains(banner)) return;
    var start0 = root().querySelector('.ondu-boost--proof') || root().querySelector('.product-details h1, h1');
    var picker = root().querySelector('variant-picker');
    if (!start0 || !picker) return;
    /* Wstaw pasek obok całej grupy z nagłówkiem (ten sam rodzic co wybór wariantu), żeby nie wchodził w jej wysokość */
    var anchor = start0;
    while (anchor.parentElement && !anchor.parentElement.contains(picker)) anchor = anchor.parentElement;
    if (!anchor.parentNode) return;
    banner = document.createElement('div');
    banner.className = 'ondu-bf-banner';
    banner.innerHTML =
      '<span class="ondu-bf-banner__eyebrow">' + esc(cfg.eyebrow) + '</span>' +
      '<strong class="ondu-bf-banner__title">' + esc(gifts ? cfg.titleGifts : sale ? (cfg.titleSale || cfg.titleCode) : cfg.titleCode) + '</strong>' +
      (cfg.countdown && end ? '<span class="ondu-bf-banner__count" data-ondu-bf-count></span>' : '');
    anchor.parentNode.insertBefore(banner, anchor);
    countdownEl = banner.querySelector('[data-ondu-bf-count]');
    tick();
  }
  function tick() {
    if (!countdownEl || !end) return;
    var now = new Date();
    if (start && now < start) {
      var pre = (cfg.startsText || 'Startuje') + ' ' + ('0' + start.getDate()).slice(-2) + '.' + ('0' + (start.getMonth() + 1)).slice(-2) + ' o ' + ('0' + start.getHours()).slice(-2) + ':' + ('0' + start.getMinutes()).slice(-2);
      if (countdownEl.textContent !== pre) countdownEl.textContent = pre;
      return;
    }
    var ms = end - now;
    if (ms <= 0) { countdownEl.textContent = cfg.endedText || ''; return; }
    var mins = Math.floor(ms / 60000);
    var d = Math.floor(mins / 1440), h = Math.floor((mins % 1440) / 60), m = mins % 60;
    var txt = (cfg.countdownPrefix || 'Kończy się za') + ' ' + (d ? d + ' d ' : '') + h + ' h ' + ('0' + m).slice(-2) + ' min';
    if (countdownEl.textContent !== txt) countdownEl.textContent = txt;
  }

  /* 2. Kafelki pakietów: cena za parę (z gratisem lub rabatem) i znaczek z ofertą */
  function perPairText(val, o) {
    var price = minByValue[val], pairs = leadingNumber(val);
    if (price === undefined || !pairs || singlePair === null) return '';
    var got = pairs, pay = price;
    if (active(o)) { if (gifts) got = pairs + o.gift; else pay = price * (1 - o.off / 100); }
    var save = singlePair * got - pay;
    return save >= 100 ? 'Oszczędzasz <b>' + zl(save) + '</b>' : '';
  }
  function decoratePacks() {
    var fs = packFieldset();
    if (!fs) return;
    fs.querySelectorAll('label').forEach(function (label) {
      var input = label.querySelector('input');
      if (!input) return;
      var o = offerFor(input.value);
      var ppHtml = perPairText(input.value, o);
      var pp = label.querySelector('.ondu-bf-pp');
      if (!ppHtml && pp) pp.remove();
      if (ppHtml) {
        if (!pp) { pp = document.createElement('span'); pp.className = 'ondu-bf-pp'; var nameEl = label.querySelector('.variant-option__button-label__text'); if (nameEl && nameEl.nextSibling) label.insertBefore(pp, nameEl.nextSibling); else label.appendChild(pp); }
        if (pp.getAttribute('data-k') !== ppHtml) { pp.setAttribute('data-k', ppHtml); pp.innerHTML = ppHtml; }
      }
      var has = label.querySelector('.ondu-bf-chip');
      if (!active(o)) { if (has) has.remove(); return; }
      var txt = gifts ? '+' + o.gift + ' gratis' : '−' + o.off + '%';
      if (has) { if (has.textContent !== txt) has.textContent = txt; return; }
      var chip = document.createElement('span');
      chip.className = 'ondu-bf-chip';
      chip.textContent = txt;
      label.appendChild(chip);
      label.classList.add('ondu-bf-has');
    });
  }

  /* 3. Ramka z ofertą dla wybranego pakietu, pod wyborem wariantu */
  var box = null;
  function placeBox() {
    if (box && document.body.contains(box)) return;
    var picker = root().querySelector('variant-picker');
    if (!picker) return;
    var host = picker.closest('.shopify-block, [data-block-id]') || picker;
    box = document.createElement('div');
    box.className = 'ondu-bf-offer';
    box.setAttribute('aria-live', 'polite');
    host.parentNode.insertBefore(box, host.nextSibling);
    box.addEventListener('click', function (e) {
      var pickBtn = e.target.closest('[data-ondu-bf-pick]');
      if (pickBtn) {
        e.preventDefault();
        var fs = packFieldset();
        var want = pickBtn.getAttribute('data-ondu-bf-pick');
        if (fs) fs.querySelectorAll('input').forEach(function (inp) { if (norm(inp.value) === norm(want)) inp.click(); });
        return;
      }
      var copyBtn = e.target.closest('[data-ondu-bf-copy]');
      if (copyBtn) {
        e.preventDefault();
        var done = function () { copyBtn.textContent = 'Skopiowano'; setTimeout(function () { copyBtn.textContent = 'Kopiuj kod'; }, 1800); };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(cfg.code).then(done, done);
        else done();
      }
    });
  }

  function bestUpsell(currentPairs) {
    var best = null;
    offers.forEach(function (o) {
      if (!active(o) || minByValue[o.value] === undefined) return;
      var n = leadingNumber(o.value);
      if (n > currentPairs && (!best || n < leadingNumber(best.value))) best = o;
    });
    return best;
  }

  function renderBox() {
    if (!box) return;
    var v = currentVariant();
    if (!v || idx < 0) return;
    var val = v.options[idx];
    var pairs = leadingNumber(val);
    var o = offerFor(val);
    var key = v.id + '|' + v.price + '|' + cfg.mode;
    if (box.getAttribute('data-for') === key) return;
    box.setAttribute('data-for', key);
    var html = '';
    if (active(o) && pairs) {
      var pay = gifts ? v.price : v.price * (1 - o.off / 100);
      var got = gifts ? pairs + o.gift : pairs;
      var per = pay / got;
      var save = singlePair ? singlePair * got - pay : 0;
      if (gifts) {
        html += '<div class="ondu-bf-offer__head">' + svgGift() + '<p><strong>Dostajesz ' + got + ' ' + pary(got) + ' zamiast ' + pairs + '</strong>' +
          '<span>' + zl(per) + ' za parę' + (save > 0 ? ' · oszczędzasz ' + zl(save) + ' względem pojedynczych par' : '') + '</span></p></div>';
        if (cfg.noteGifts) html += '<p class="ondu-bf-offer__note">' + esc(cfg.noteGifts) + '</p>';
      } else if (sale) {
        html += '<div class="ondu-bf-offer__head">' + svgTag() + '<p><strong>Cena Black Friday: ' + zl(pay) + ' <s>' + zl(v.price) + '</s></strong>' +
          '<span>' + zl(per) + ' za parę' + (save > 0 ? ' · oszczędzasz ' + zl(save) + ' względem pojedynczych par' : '') + '</span></p></div>';
        if (cfg.noteSale) html += '<p class="ondu-bf-offer__note">' + esc(cfg.noteSale) + '</p>';
      } else {
        html += '<div class="ondu-bf-offer__head">' + svgTag() + '<p><strong>Z kodem: ' + zl(pay) + ' <s>' + zl(v.price) + '</s></strong>' +
          '<span>' + zl(per) + ' za parę' + (save > 0 ? ' · oszczędzasz ' + zl(save) + ' względem pojedynczych par' : '') + '</span></p></div>';
        html += '<div class="ondu-bf-code"><span class="ondu-bf-code__label">Kod</span><b>' + esc(cfg.code) + '</b><button type="button" data-ondu-bf-copy>Kopiuj kod</button></div>';
        if (cfg.noteCode) html += '<p class="ondu-bf-offer__note">' + esc(cfg.noteCode) + '</p>';
      }
      if (cfg.newsletter) html += '<p class="ondu-bf-offer__nl">' + esc(cfg.newsletter) + '</p>';
      box.classList.remove('is-upsell');
    } else {
      var up = bestUpsell(pairs || 0);
      if (!up) { box.hidden = true; return; }
      var upPairs = leadingNumber(up.value);
      var upText = gifts
        ? 'Weź ' + upPairs + ' ' + pary(upPairs) + ', a ' + (up.gift === 1 ? (upPairs + 1) + '. dostaniesz gratis' : up.gift + ' kolejne dostaniesz gratis')
        : 'Weź ' + upPairs + ' ' + pary(upPairs) + ', a ' + (sale ? 'zapłacisz ' : 'z kodem zapłacisz ') + up.off + '% mniej';
      var upPer = gifts ? minByValue[up.value] / (upPairs + up.gift) : minByValue[up.value] * (1 - up.off / 100) / upPairs;
      html += '<div class="ondu-bf-offer__head">' + (gifts ? svgGift() : svgTag()) + '<p><strong>' + esc(upText) + '</strong>' +
        '<span>Black Friday: ' + zl(upPer) + ' za parę</span></p></div>' +
        '<button type="button" class="ondu-bf-offer__pick" data-ondu-bf-pick="' + esc(up.value) + '">Wybierz ' + esc(up.value) + '</button>';
      box.classList.add('is-upsell');
    }
    box.hidden = false;
    box.innerHTML = html;
  }

  /* 4. Obniżka automatyczna: przekreślona cena przy cenie produktu i w przyklejonym pasku */
  function subSelected() {
    var w = root().querySelector('.appstle_sub_widget');
    if (!w) return false;
    var o = w.querySelector('.appstle_subscription_wrapper_option.appstle_include_dropdown') ||
      (w.querySelector('.appstle_subscription_radio_wrapper') || {}).parentElement;
    var r = o && o.querySelector('input[type="radio"]');
    return !!(r && r.checked);
  }
  function renderPrice() {
    if (!sale) return;
    var v = currentVariant();
    var priceEl = root().querySelector('product-price');
    var mine = root().querySelector('.ondu-bf-price');
    var o = v && idx >= 0 ? offerFor(v.options[idx]) : null;
    var on = !!(priceEl && v && active(o) && !subSelected());
    var sticky = document.querySelector('[data-ondu-sticky-price]');
    var stickyMine = document.querySelector('.ondu-bf-sticky-price');
    document.documentElement.classList.toggle('ondu-bf-sale-on', on);
    if (!on) {
      if (priceEl) priceEl.classList.remove('ondu-bf-hidden');
      if (mine) mine.remove();
      if (stickyMine) stickyMine.remove();
      return;
    }
    var now = v.price * (1 - o.off / 100);
    var html = '<span class="ondu-bf-price__now">' + zl(now) + '</span>' +
      '<s class="ondu-bf-price__was">' + zl(v.price) + '</s>' +
      '<span class="ondu-bf-price__off">−' + o.off + '%</span>' +
      (cfg.omnibusText ? '<span class="ondu-bf-price__omni">' + esc(cfg.omnibusText) + ' ' + zl(v.price) + '</span>' : '');
    if (!mine) {
      mine = document.createElement('div');
      mine.className = 'ondu-bf-price';
      priceEl.parentNode.insertBefore(mine, priceEl.nextSibling);
    } else if (mine.previousElementSibling !== priceEl) {
      priceEl.parentNode.insertBefore(mine, priceEl.nextSibling);
    }
    if (mine.getAttribute('data-k') !== html) { mine.setAttribute('data-k', html); mine.innerHTML = html; }
    if (!priceEl.classList.contains('ondu-bf-hidden')) {
      mine.style.fontSize = getComputedStyle(priceEl).fontSize;
      priceEl.classList.add('ondu-bf-hidden');
    }
    if (sticky) {
      var sh = '<s>' + zl(v.price) + '</s>' + zl(now);
      if (!stickyMine) {
        stickyMine = document.createElement('b');
        stickyMine.className = 'ondu-bf-sticky-price';
        sticky.parentNode.insertBefore(stickyMine, sticky.nextSibling);
      }
      if (stickyMine.innerHTML !== sh) stickyMine.innerHTML = sh;
    }
  }

  /* Opcjonalnie: kod rabatowy dodawany sam do koszyka (Shopify /discount/KOD), raz na wizytę */
  function applyAutoCode() {
    if (!sale || !cfg.autoCode) return;
    try { if (sessionStorage.getItem('onduBfCode') === cfg.autoCode) return; sessionStorage.setItem('onduBfCode', cfg.autoCode); } catch (e) {}
    try { fetch('/discount/' + encodeURIComponent(cfg.autoCode), { credentials: 'same-origin', redirect: 'manual' }); } catch (e) {}
  }

  var running = false;
  function run() {
    if (running) return;
    running = true;
    try {
      if (idx < 0) prepPrices();
      placeBanner();
      decoratePacks();
      if (cfg.showBox) { placeBox(); renderBox(); }
      renderPrice();
    } catch (e) {}
    running = false;
  }

  function init() {
    document.documentElement.classList.add('ondu-bf-on');
    applyAutoCode();
    run();
    setInterval(tick, 30000);
    var r = root();
    if ('MutationObserver' in window) new MutationObserver(run).observe(r === document ? document.body : r, { childList: true, subtree: true });
    document.addEventListener('change', function () { run(); setTimeout(run, 150); });
    document.addEventListener('variant:update', run);
    var tries = 0;
    var poll = setInterval(function () { run(); if (++tries > 20) clearInterval(poll); }, 500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
